import store from "@/store";
import { mapGetters, mapState } from "vuex";
import { isUserInRole } from "@/oidc/roleRestricted.directive";

export const userMixin = {
  computed: {
    ...mapState({
      user: state => state.user,
      roles: state => state.user.roles,
      restricted_to_orgs: state => state.user.restricted_to_orgs,
    }),
    ...mapGetters({
      userId: "user/username",
      userEmail: "user/email",
      userFullName: "user/full_name",
      userWardId: "user/ward_id",
      userStakeId: "user/stake_id",
      userTokenExpired: "user/isTokenExpired",
      userRestrictedOrgs: "user/restricted_to_orgs",
      userAvailableWardRoles: "user/available_ward_roles",

    }),
  },
  methods: {
    getUserProfile(takeToWard=true) {
      store.dispatch("user/loadUser", takeToWard);
    },
    isInRole(roleName) {
        //console.log(roleName);
      return isUserInRole(roleName, this.roles);
    },
    formatPhoneNumber(value) {
        const r = value.replace(/\D/g, '');
        const x = r.match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        if (r.length === 10)
          return !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
        const y = r.match(/(\d{0,1})(\d{0,3})(\d{0,3})(\d{0,4})/)
        if (r.length === 11)
          return !y[3] ? y[2] : '+' + y[1] + ' (' + y[2] + ') ' + y[3] + (y[4] ? '-' + y[4] : '');

    }
  },
};
